import React, { useEffect } from "react";
import { calendar } from "../../assets/icons";
import { blogdetails } from "../../assets/images";
import "./knowledge.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/helper";

const BlogDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const blog = state?.blog;

  useEffect(()=> {
    if(!blog) {
      navigate("/knowledge-center");
    }
  },[blog]);

  return (
    <div className="wrapper_blog_details">
      <div className="container">
        <div className="wrap_blog_details">
          <div className="wrap_txt_center">
            <span>
              <img src={calendar} alt="calneder-icon" />
              {formatDate(blog?.date)}
            </span>
          </div>
          <h1>
            {blog?.title?.rendered}
          </h1>
          <figure>
            <img src={
              blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details
                ?.sizes?.medium?.source_url
                ?
                blog._embedded?.["wp:featuredmedia"]?.[0]?.source_url
                :
                blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details
                  ?.sizes?.full?.source_url
                  ?
                  blog?._embedded?.["wp:featuredmedia"]?.[0]?.media_details
                    ?.sizes?.full?.source_url
                  :
                  blogdetails
            } alt="image" />
          </figure>
          <p
          dangerouslySetInnerHTML={{ __html: blog?.content?.rendered }}
          ></p>
          {/* <h3>Understanding the Journey of Mental Health</h3>
          <p>
            Arcu amet bibendum ut urna. Rutrum urna tempus praesent etiam
            gravida tristique diam. Tellus nam sit diam sem. Ut lacinia egestas
            amet aliquet. Eleifend fringilla at convallis nibh ultrices. Quis
            sit libero tincidunt adipiscing pharetra bibendum quis malesuada
            sed. Venenatis sed nulla bibendum laoreet at malesuada mauris
            fermentum integer. Sed eu odio semper risus lobortis. Amet id sit
            orci lobortis orci. Condimentum venenatis turpis vulputate elit eu
            nulla lectus nec quam. Interdum ultricies congue quisque in
            tincidunt. Amet placerat in consectetur vitae nascetur consectetur.
          </p>
          <h3>Incorporate More Whole Foods</h3>
          <p>
            Arcu amet bibendum ut urna. Rutrum urna tempus praesent etiam
            gravida tristique diam. Tellus nam sit diam sem. Ut lacinia egestas
            amet aliquet. Eleifend fringilla at convallis nibh ultrices. Quis
            sit libero tincidunt adipiscing pharetra bibendum quis malesuada
            sed. Venenatis sed nulla bibendum laoreet at malesuada mauris
            fermentum integer. Sed eu odio semper risus lobortis. Amet id sit
            orci lobortis orci. Condimentum venenatis turpis vulputate elit eu
            nulla lectus nec quam. Interdum ultricies congue quisque in
            tincidunt. Amet placerat in consectetur vitae nascetur consectetur.
          </p>
          <p>
            Arcu amet bibendum ut urna. Rutrum urna tempus praesent etiam
            gravida tristique diam. Tellus nam sit diam sem. Ut lacinia egestas
            amet aliquet. Eleifend fringilla at convallis nibh ultrices. Quis
            sit libero tincidunt adipiscing pharetra bibendum quis malesuada
            sed. Venenatis sed nulla bibendum laoreet at malesuada mauris
            fermentum integer. Sed eu odio semper risus lobortis. Amet id sit
            orci lobortis orci. Condimentum venenatis turpis vulputate elit eu
            nulla lectus nec quam. Interdum ultricies congue quisque in
            tincidunt. Amet placerat in consectetur vitae nascetur consectetur.
          </p>

          <figure>
            <img src={blogdetails1} alt="" />
          </figure>
          <h3>Steps to Starting Therapy</h3>
          <p>
            Understanding the steps to begin therapy can demystify the process.
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
            fugit, sed quia consequuntur magni dolores eos qui ratione
            voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem
            ipsum quia dolor sit amet, consectetur, adipisci velit.
          </p>
          <ol>
            <li>nitial consultation</li>
            <li>Developing a treatment plan</li>
            <li>Regular therapy sessions</li>
          </ol>
          <p>
            Regular therapy sessions help in tracking progress and making
            necessary adjustments. Ut enim ad minima veniam, quis nostrum
            exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid
            ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui
            in ea voluptate velit esse quam nihil molestiae consequatur.
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
